import script from "./OrderModify.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderModify.vue?vue&type=script&setup=true&lang=js"

import "./OrderModify.vue?vue&type=style&index=0&id=2d75abd2&lang=scss"

const __exports__ = script;

export default __exports__